export default "__VITE_ASSET__mbQ8VxGk__"